import { WifiSettingsState } from "./slice";

export const getWifiSettings = (state: WifiSettingsState) => state.wifiSettings;
